import React, { useState, useRef, useEffect } from 'react';
import CategorySelect from "./SelectCategory";

interface CreateVoucherItemProps {
  onAddItem: (item: { voucherAmount: number, voucherDescription: string, selectedCategory: string, note: string }) => void;
}

export default function CreateVoucherItem({ onAddItem }: CreateVoucherItemProps) {
  const [voucherAmount, setVoucherAmount] = useState('');
  const [voucherDescription, setVoucherDescription] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [note, setNote] = useState('');
  const [refreshCategorySelect, setRefreshCategorySelect] = useState(false);

  const descriptionInputRef = useRef<HTMLInputElement>(null);

  const handleVoucherAmountChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setVoucherAmount(event.target.value);
  };

  const handleVoucherDescriptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setVoucherDescription(event.target.value);
  };

  const handleCategorySelected = (category: string) => {
    setSelectedCategory(category);
  };

  const handleAddItem = () => {
    const evaluatedAmount = evaluateArithmeticExpression(voucherAmount);
    onAddItem({ voucherAmount: evaluatedAmount, voucherDescription, selectedCategory, note });
    setVoucherAmount('');
    setVoucherDescription('');
    setSelectedCategory('');
    setRefreshCategorySelect(true);
    if (descriptionInputRef.current) {
      descriptionInputRef.current.focus();
    }
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleAddItem();
    }
  };

  const evaluateArithmeticExpression = (expression: string): number => {
    try {
      // Use the eval function to evaluate the arithmetic expression
      return eval(expression);
    } catch (error) {
      console.error('Invalid arithmetic expression');
      return 0;
    }
  };

  useEffect(() => {
    if (refreshCategorySelect) {
      setRefreshCategorySelect(false);
    }
  }, [refreshCategorySelect]);

  return (
    <div className='Add_itemVoucher'>
      <input
        type="text"
        placeholder="Voucher Description"
        value={voucherDescription}
        onChange={handleVoucherDescriptionChange}
        ref={descriptionInputRef}
      />
      <input
        type="text"
        placeholder="Voucher Amount"
        value={voucherAmount}
        onChange={handleVoucherAmountChange}
        onKeyPress={handleKeyPress}
      />
      <CategorySelect key={refreshCategorySelect ? 'refresh' : 'default'} onCategorySelected={handleCategorySelected} />
      <button className='button_one' onClick={handleAddItem}>Add Item</button>
    </div>
  );
}
